<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action="https://api.i-vce.com/teacher/common/upload"
      list-type="picture-card"
      :on-success="handleImgSuccess"
      :headers="headers"
      :show-file-list="false"
      :before-upload="beforeUpload"
      accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
    >
      <div class="avatar-uploader_div" v-if="images">
        <img :src="images" class="avatar" />
        <div class="zhezhao">
          <el-icon @click.stop="viewImages" :size="24">
            <Search color="#ffffff" />
          </el-icon>
          <el-icon @click.stop="handleRemove" :size="24">
            <Delete color="#ffffff" />
          </el-icon>
        </div>
      </div>
      <el-icon v-else class="avatar-uploader-icon">
        <Plus />
      </el-icon>
    </el-upload>

    <el-dialog v-model="dialogVisible">
      <img w-full :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headers: {},
      images: "",
      dialogVisible: false,
    };
  },
  mounted() {
    this.headers = {
      token: localStorage.getItem("tokenReload"),
    };
    // this.addEventListenerCopy();
  },
  methods: {
    async uploadImagesBlob(e) {
      const response = await fetch(e);
      const blob = await response.blob();

      // 转换为 File 对象（可选）
      const file = new File(
        [blob],
        `image-${Date.now()}.${blob.type.split("/")[1]}`,
        { type: blob.type }
      );
      this.uploadImgToOSS(file).then((res) => {
        console.error("====图片上传成功", res);
        this.images = res;
      });
    },
    getImagesUrl() {
      return this.images;
    },
    beforeUpload(file) {
      // const FILE_NAME = file.name
      // console.error('@@@', FILE_NAME.substring(FILE_NAME.lastIndexOf('.')))
      // if (FILE_NAME.substring(FILE_NAME.lastIndexOf('.')) !== '.xls' && FILE_NAME.substring(FILE_NAME.lastIndexOf('.')) !== '.xlsx') {
      //   this.$message.warning('请上传正确格式的图片')
      //   return false
      // }
      const isLt1M = file.size / 1024 / 1024 < 30;
      if (isLt1M) {
        this.file = file;
        return true;
      }
      this.$message.warning("请上传不超过30M的文件");
      return false;
    },
    handleImgSuccess(e) {
      this.images = e.data.fullurl;
    },
    handleRemove() {
      this.images = "";
    },
    viewImages() {
      this.dialogImageUrl = this.images;
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.el-upload--picture-card i {
  margin-top: 0;
}

.avatar-uploader_div {
  width: 148px;
  height: 148px;
  display: block;
  position: relative;
}

.avatar-uploader .avatar {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.zhezhao {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 12px;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.zhezhao:hover {
  opacity: 1;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

/deep/.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  text-align: center;
}
</style>
